!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define("ati-ui-react", ["react"], t) : "object" == typeof exports ? exports["ati-ui-react"] = t(require("react")) : e["ati-ui-react"] = t(e.React);
}(this, function (n) {
  return i = {}, o.m = r = {
    0: function (e, t) {
      e.exports = n;
    },
    10: function (e, t, n) {
      "use strict";

      n.d(t, "b", function () {
        return r;
      }), n.d(t, "a", function () {
        return o;
      });
      var r = function (t) {
          for (var e = arguments.length, n = Array(1 < e ? e - 1 : 0), r = 1; r < e; r++) n[r - 1] = arguments[r];
          return n.filter(Boolean).map(function (e) {
            return t[e];
          }).join(" ");
        },
        o = function () {
          for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) t[n] = arguments[n];
          return t.filter(Boolean).join(" ");
        };
    },
    117: function (e, t, n) {
      "use strict";

      var i = n(0),
        c = n.n(i),
        a = n(10),
        r = n(2),
        o = n.n(r),
        r = n(96),
        n = n.n(r),
        r = {
          insert: "head",
          singleton: !1
        },
        u = (o()(n.a, r), n.a.locals || {});
      function l(e) {
        return (l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function s() {
        return (s = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n,
              r = arguments[t];
            for (n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
          return e;
        }).apply(this, arguments);
      }
      function f(e, t) {
        if (null == e) return {};
        var n,
          r = function (e, t) {
            if (null == e) return {};
            var n,
              r,
              o = {},
              i = Object.keys(e);
            for (r = 0; r < i.length; r++) n = i[r], ~t.indexOf(n) || (o[n] = e[n]);
            return o;
          }(e, t);
        if (Object.getOwnPropertySymbols) for (var o = Object.getOwnPropertySymbols(e), i = 0; i < o.length; i++) n = o[i], ~t.indexOf(n) || Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
        return r;
      }
      function p(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      function d(e, t) {
        return (d = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }
      function b(n) {
        var r = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }();
        return function () {
          var e,
            t = h(n);
          return e = r ? (e = h(this).constructor, Reflect.construct(t, arguments, e)) : t.apply(this, arguments), t = this, !(e = e) || "object" !== l(e) && "function" != typeof e ? function (e) {
            if (void 0 !== e) return e;
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }(t) : e;
        };
      }
      function h(e) {
        return (h = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }
      n = function () {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && d(e, t);
        }(o, i["PureComponent"]);
        var e,
          t,
          n,
          r = b(o);
        function o() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, o), r.apply(this, arguments);
        }
        return e = o, (t = [{
          key: "getClassName",
          value: function () {
            var e = this.props.size,
              t = [Object(a.a)(u["ati-core-checkbox"], this.props.className)];
            return e && "small" === e && t.push(u["ati-small"]), t.join(" ");
          }
        }, {
          key: "render",
          value: function () {
            var e = this.props,
              t = e.checked,
              n = e.onChange,
              r = e.readOnly,
              o = e.disabled,
              i = e.label,
              a = (e.className, e.dataQa),
              e = f(e, ["checked", "onChange", "readOnly", "disabled", "label", "className", "dataQa"]);
            return c.a.createElement("label", {
              className: this.getClassName(),
              "data-qa": a
            }, c.a.createElement("input", s({
              checked: t,
              onChange: n,
              type: "checkbox",
              readOnly: r,
              disabled: o
            }, e)), c.a.createElement("span", null, i));
          }
        }]) && p(e.prototype, t), n && p(e, n), o;
      }();
      n.defaultProps = {
        dataQa: "checkbox"
      };
      t.a = n;
    },
    2: function (e, t, o) {
      "use strict";

      var n,
        r,
        c = function () {
          return n = void 0 === n ? !(!(window && document && document.all) || window.atob) : n;
        },
        i = (r = {}, function (e) {
          if (void 0 === r[e]) {
            var t = document.querySelector(e);
            if (window.HTMLIFrameElement && t instanceof window.HTMLIFrameElement) try {
              t = t.contentDocument.head;
            } catch (e) {
              t = null;
            }
            r[e] = t;
          }
          return r[e];
        }),
        l = [];
      function s(e) {
        for (var t = -1, n = 0; n < l.length; n++) if (l[n].identifier === e) {
          t = n;
          break;
        }
        return t;
      }
      function u(e, t) {
        for (var n = {}, r = [], o = 0; o < e.length; o++) {
          var i = e[o],
            a = t.base ? i[0] + t.base : i[0],
            c = n[a] || 0,
            u = "".concat(a, " ").concat(c);
          n[a] = c + 1;
          c = s(u), i = {
            css: i[1],
            media: i[2],
            sourceMap: i[3]
          };
          -1 !== c ? (l[c].references++, l[c].updater(i)) : l.push({
            identifier: u,
            updater: function (t, e) {
              var n, r, o;
              {
                var i;
                o = e.singleton ? (i = h++, n = b = b || f(e), r = d.bind(null, n, i, !1), d.bind(null, n, i, !0)) : (n = f(e), r = function (e, t, n) {
                  var r = n.css,
                    o = n.media,
                    n = n.sourceMap;
                  o ? e.setAttribute("media", o) : e.removeAttribute("media");
                  n && "undefined" != typeof btoa && (r += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(n)))), " */"));
                  if (e.styleSheet) e.styleSheet.cssText = r;else {
                    for (; e.firstChild;) e.removeChild(e.firstChild);
                    e.appendChild(document.createTextNode(r));
                  }
                }.bind(null, n, e), function () {
                  !function (e) {
                    if (null === e.parentNode) return;
                    e.parentNode.removeChild(e);
                  }(n);
                });
              }
              return r(t), function (e) {
                e ? e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap || r(t = e) : o();
              };
            }(i, t),
            references: 1
          }), r.push(u);
        }
        return r;
      }
      function f(e) {
        var t,
          n = document.createElement("style"),
          r = e.attributes || {};
        if (void 0 !== r.nonce || (t = o.nc) && (r.nonce = t), Object.keys(r).forEach(function (e) {
          n.setAttribute(e, r[e]);
        }), "function" == typeof e.insert) e.insert(n);else {
          e = i(e.insert || "head");
          if (!e) throw Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
          e.appendChild(n);
        }
        return n;
      }
      var a,
        p = (a = [], function (e, t) {
          return a[e] = t, a.filter(Boolean).join("\n");
        });
      function d(e, t, n, r) {
        n = n ? "" : r.media ? "@media ".concat(r.media, " {").concat(r.css, "}") : r.css;
        e.styleSheet ? e.styleSheet.cssText = p(t, n) : (r = document.createTextNode(n), (n = e.childNodes)[t] && e.removeChild(n[t]), n.length ? e.insertBefore(r, n[t]) : e.appendChild(r));
      }
      var b = null,
        h = 0;
      e.exports = function (e, i) {
        (i = i || {}).singleton || "boolean" == typeof i.singleton || (i.singleton = c());
        var a = u(e = e || [], i);
        return function (e) {
          if ("[object Array]" === Object.prototype.toString.call(e = e || [])) {
            for (var t = 0; t < a.length; t++) {
              var n = s(a[t]);
              l[n].references--;
            }
            for (var e = u(e, i), r = 0; r < a.length; r++) {
              var o = s(a[r]);
              0 === l[o].references && (l[o].updater(), l.splice(o, 1));
            }
            a = e;
          }
        };
      };
    },
    4: function (e, t) {
      e.exports = function () {
        var a = [];
        return a.toString = function () {
          for (var e = [], t = 0; t < this.length; t++) {
            var n = this[t];
            n[2] ? e.push("@media " + n[2] + "{" + n[1] + "}") : e.push(n[1]);
          }
          return e.join("");
        }, a.i = function (e, t) {
          "string" == typeof e && (e = [[null, e, ""]]);
          for (var n = {}, r = 0; r < this.length; r++) {
            var o = this[r][0];
            "number" == typeof o && (n[o] = !0);
          }
          for (r = 0; r < e.length; r++) {
            var i = e[r];
            "number" == typeof i[0] && n[i[0]] || (t && !i[2] ? i[2] = t : t && (i[2] = "(" + i[2] + ") and (" + t + ")"), a.push(i));
          }
        }, a;
      };
    },
    421: function (e, t, n) {
      "use strict";

      n.r(t);
      var r = n(117);
      n.d(t, "default", function () {
        return r.a;
      });
    },
    96: function (e, t, n) {
      (t = e.exports = n(4)()).push([e.i, "._2Cstc-2-0-721{font-family:Verdana,Dejavu Sans,Geneva,Tahoma,sans-serif;cursor:pointer;padding-top:1px;line-height:normal;outline:0;position:relative}._2Cstc-2-0-721 input{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;border:0;clip:rect(0 0 0 0)}._2Cstc-2-0-721 input:focus:checked~span:before{border:1px solid #3167b5}._2Cstc-2-0-721 input:focus:not(:checked)~span:before{border:1px solid #8c969d}._2Cstc-2-0-721 input+span{display:inline-block;position:relative;vertical-align:top;font-size:12px;font-weight:400;padding-left:25px;color:#39444f;line-height:1.2;padding-top:1px;letter-spacing:.1px}._2Cstc-2-0-721 input+span:before{content:\"\";position:absolute;padding:2px;left:0;top:-1px;width:18px;height:18px;display:inline-block;background-color:#fff;border:1px solid #ccc;border-radius:2px;color:#fff;box-sizing:border-box}._2Cstc-2-0-721 input:checked+span:after{content:\"\";position:absolute;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='12' height='9' viewBox='0 0 12 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 4l1.6-1.6 3.2 3.2L10.4 0 12 1.6 4.8 8.8 0 4z' fill='%23fff'/%3E%3C/svg%3E\");top:4px;left:3px;width:12px;height:9px}._2Cstc-2-0-721 input+span:hover:before{background-color:#e7f0f8;border:1px solid #ccc}._2Cstc-2-0-721 input:checked+span:hover:before{background-color:#3a7bbf}._2Cstc-2-0-721 input:checked+span:focus:before,._2Cstc-2-0-721 input:checked:focus+span:before{background:#478cc8;border:1px solid #3167b5}._2Cstc-2-0-721 input:checked+span:active:before{background-color:#3167b5}._2Cstc-2-0-721 input:checked+span:before{background:#478cc8;border:1px solid transparent}._2Cstc-2-0-721 input[disabled]+span:before{background-color:#f1f1f1;border:1px solid #ccc}._2Cstc-2-0-721 input[disabled]+span{color:#b8b8b8;cursor:not-allowed}._2Cstc-2-0-721 input[disabled]:checked+span:before{background:#478cc8;border:1px solid transparent;opacity:.8}._2Cstc-2-0-721.HgAOx-2-0-721 input+span{padding-left:18px;font-size:12px}._2Cstc-2-0-721.HgAOx-2-0-721 input+span:before{width:12px;height:12px;top:2px}._2Cstc-2-0-721.HgAOx-2-0-721 input:checked+span:after{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 2.667L1.067 1.6 3.2 3.733 6.933 0 8 1.067l-4.8 4.8-3.2-3.2z' fill='%23fff'/%3E%3C/svg%3E\");top:5px;left:2px;width:8px;height:6px}", ""]), t.locals = {
        "ati-core-checkbox": "_2Cstc-2-0-721",
        "ati-small": "HgAOx-2-0-721"
      };
    }
  }, o.c = i, o.d = function (e, t, n) {
    o.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, o.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, o.t = function (t, e) {
    if (1 & e && (t = o(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var n = Object.create(null);
    if (o.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var r in t) o.d(n, r, function (e) {
      return t[e];
    }.bind(null, r));
    return n;
  }, o.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return o.d(t, "a", t), t;
  }, o.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, o.p = "", o(o.s = 421);
  function o(e) {
    if (i[e]) return i[e].exports;
    var t = i[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return r[e].call(t.exports, t, t.exports, o), t.l = !0, t.exports;
  }
  var r, i;
});